import { api } from "@ts/core/api";
import { popMessage } from "@ts/core/Popup";
import { Utils } from "@ts/core/Utils";

interface UserData   {
    username: string;
    fullname: string;
    email:string;
}

export class UserTool {

    public static add(): void {

        const form = document.createElement('form');

        form.innerHTML = Utils.minify( `
              <h2>Ny användare</h2>

              <label for="username">Användarnamn</label>
              <input type="text" id="username" required>

              <label for="fullname">Fullständigt namn</label>
              <input type="text" id="fullname" required>
                
              <label for="email">E-Post</label>
              <input type="email" id="email" required>
                
              <label for="password">Lösenord</label>
              <input type="password" id="password" required>
                
              <hr>
              <div class="buttons">
                <button id="save">Spara</button>
                <button id="abort">Avbryt</button>
            </div>
            `);

        document.body.appendChild(form);

        const usernameElement = form.querySelector('#username') as HTMLInputElement;
        const fullnameElement = form.querySelector('#fullname') as HTMLInputElement;
        const emailElement = form.querySelector('#email') as HTMLInputElement;
        const passwordElement = form.querySelector('#password') as HTMLInputElement;
        const saveButton = form.querySelector('#save') as HTMLInputElement;
        const abortButton = form.querySelector('#abort') as HTMLInputElement;

        abortButton.addEventListener('click', (e:Event) => {
            e.preventDefault();
            form.remove();
        });

        saveButton.addEventListener('click', async (e:Event)=> {
            e.preventDefault();
            const resp = await api<boolean>('userAdd', {
                username: usernameElement.value,
                fullname: fullnameElement.value,
                email: emailElement.value,
                password: passwordElement.value
            });
            if( resp ) popMessage('Användaren har lagts till');
            form.remove();

        });

    }
    public static async edit(): Promise<void> {
        const form = document.createElement('form');

        form.innerHTML = Utils.minify( `
              <h2>Redigera användare</h2>

              <label for="select-user">Välj användare</label>
              ${await UserTool.createUserList()}
              
              <label for="username">Användarnamn</label>
              <input read-only type="text" id="username">

              <label for="fullname">Fullständigt namn</label>
              <input type="text" id="fullname">
                
              <label for="email">E-Post</label>
              <input type="email" id="email">
                
              <hr>
              <div class="buttons">
                <button id="save" disabled>Spara</button>
                <button id="abort">Avbryt</button>
            </div>
            `);

        document.body.appendChild(form);

        const selectElemet = form.querySelector('select') as HTMLSelectElement;
        const usernameElement = form.querySelector('#username') as HTMLInputElement;
        const fullnameElement = form.querySelector('#fullname') as HTMLInputElement;
        const emailElement = form.querySelector('#email') as HTMLInputElement;
        const saveButton = form.querySelector('#save') as HTMLInputElement;
        const abortButton = form.querySelector('#abort') as HTMLInputElement;

        selectElemet.addEventListener('change', (e:Event) => {
            e.preventDefault();
            const opt = selectElemet.options[selectElemet.selectedIndex];
            usernameElement.value = opt.value;
            fullnameElement.value = opt.innerText;
            emailElement.value = opt.getAttribute('data-email') as string;
            saveButton.disabled = false;
        });

        abortButton.addEventListener('click', (e:Event) => {
            e.preventDefault();
            form.remove();
        });

        saveButton.addEventListener('click', async (e:Event)=> {
            e.preventDefault();
            const resp = await api<boolean>('userEdit', {
                username: usernameElement.value,
                fullname: fullnameElement.value,
                email: emailElement.value
            });
            if( resp ) popMessage('Användaren har uppdaterats');
            form.remove();
        });
    }

    public static async delete(): Promise<void> {
        const form = document.createElement('form');

        form.innerHTML = Utils.minify( `
              <h2>Radera användare</h2>

              <label for="select-user">Välj användare</label>
              ${await UserTool.createUserList()}
              
              <label for="username">Användarnamn</label>
              <input read-only type="text" id="username">

              <label for="fullname">Fullständigt namn</label>
              <input read-only type="text" id="fullname">
                
              <label for="email">E-Post</label>
              <input read-only type="email" id="email">
                
              <hr>
              <div class="buttons">
                <button id="delete" disabled>Radera</button>
                <button id="abort">Avbryt</button>
            </div>
            `);

        document.body.appendChild(form);

        const selectElemet = form.querySelector('select') as HTMLSelectElement;
        const usernameElement = form.querySelector('#username') as HTMLInputElement;
        const fullnameElement = form.querySelector('#fullname') as HTMLInputElement;
        const emailElement = form.querySelector('#email') as HTMLInputElement;
        const deleteButton = form.querySelector('#delete') as HTMLInputElement;
        const abortButton = form.querySelector('#abort') as HTMLInputElement;

        selectElemet.addEventListener('change', (e:Event) => {
            e.preventDefault();
            const opt = selectElemet.options[selectElemet.selectedIndex];
            usernameElement.value = opt.value;
            fullnameElement.value = opt.innerText;
            emailElement.value = opt.getAttribute('data-email') as string;
            deleteButton.disabled = false;
        });

        abortButton.addEventListener('click', (e:Event) => {
            e.preventDefault();
            form.remove();
        });

        deleteButton.addEventListener('click', async (e:Event)=> {
            e.preventDefault();
            const resp = await api<boolean>('userDelete', {
                username: usernameElement.value
            });
            if( resp ) popMessage('Användaren har raderats');
            form.remove();
        });
    }

    public static async password() : Promise<void> {
        const form = document.createElement('form');

        form.innerHTML = Utils.minify( `
              <h2>Läsenord för användare</h2>

              <label for="select-user">Välj användare</label>
              ${await UserTool.createUserList()}
              
              <label for="username">Användarnamn</label>
              <input read-only type="text" id="username">

              <label for="fullname">Fullständigt namn</label>
              <input read-only type="text" id="fullname">
                
              <label for="password">Lösenord</label>
              <input type="password" id="password">
                
              <hr>
              <div class="buttons">
                <button id="update" disabled>Updatera</button>
                <button id="abort">Avbryt</button>
            </div>
            `);

        document.body.appendChild(form);

        const selectElemet = form.querySelector('select') as HTMLSelectElement;
        const usernameElement = form.querySelector('#username') as HTMLInputElement;
        const fullnameElement = form.querySelector('#fullname') as HTMLInputElement;
        const passwordElement = form.querySelector('#password') as HTMLInputElement;
        const updateButton = form.querySelector('#update') as HTMLInputElement;
        const abortButton = form.querySelector('#abort') as HTMLInputElement;

        selectElemet.addEventListener('change', (e:Event) => {
            e.preventDefault();
            const opt = selectElemet.options[selectElemet.selectedIndex];
            usernameElement.value = opt.value;
            fullnameElement.value = opt.innerText;
            updateButton.disabled = false;
        });

        abortButton.addEventListener('click', (e:Event) => {
            e.preventDefault();
            form.remove();
        });

        updateButton.addEventListener('click', async (e:Event)=> {
            e.preventDefault();
            const resp = await api<boolean>('userPassword', {
                username: usernameElement.value,
                password: passwordElement.value,
            });
            if( resp ) popMessage('Lösenordet har uppdaterats');
            form.remove();
        });

    }

    private static async createUserList() : Promise<string> {

        const resp = await api<Array<UserData>>('usersGet');
        if( !resp) return '<select><&select>';
        
        const select = document.createElement('select');
        select.id='select-user';
        select.innerHTML = '<option value="">---</option>';
        for( let i=0; i < resp.length; i++) {
            const user = resp[i];
            const option = document.createElement('option');
            option.value = user.username;
            option.innerText = user.fullname;
            option.setAttribute('data-email', user.email);
            select.appendChild(option);
        }
        return select.outerHTML;
    }
}
